import { BodyText, Button, Link } from '@utilitywarehouse/hearth-react';

import { Dialog, DialogActions, DialogID, useDialog } from '@components/Dialog';
import type { AnchoredServiceType } from '@generated/gql/graphql';

import './styles.scss';

type Service = {
  type: AnchoredServiceType;
};

interface AddressSuppliedModalProps {
  services: Service[];
  onContinue?: () => void;
}
export const formatServices = (services: Service[]) => {
  const map: Record<AnchoredServiceType, string> = {
    ELECTRICITY: 'energy',
    GAS: 'energy',
    FIXED_LINE_BROADBAND: 'broadband',
    FIXED_LINE_VOICE: 'broadband',
    FIXED_LINE_NGN: 'broadband',
    BOILER_INSURANCE: 'insurance',
    HOME_INSURANCE: 'insurance',
    FIT: 'energy',
  };
  const grouped = new Set<string>();

  for (const service of services) {
    const label = map[service.type];
    if (label) grouped.add(label);
  }

  return Array.from(grouped);
};
const AddressSuppliedModal = ({
  services,
  onContinue,
}: AddressSuppliedModalProps) => {
  const dialog = useDialog(DialogID.ADDRESS_ALREADY_SUPPLIED);

  const handleClose = () => dialog.setOpen(false);

  const formattedServices = formatServices(services);

  const serviceText =
    formattedServices.length > 0 ? formattedServices.join(' and ') : 'services';

  return (
    <Dialog
      id={dialog.id}
      hideCloseButton
      onClose={handleClose}
      heading="We already supply this address"
    >
      <BodyText>
        It looks like we already supply this address with {serviceText}. If you
        have recently moved into this property, please call the Home Movers team
        on{' '}
        <Link href="tel:03337770888" className="phoneLink">
          0333 777 0 888
        </Link>
        .
      </BodyText>
      <DialogActions>
        <Button
          variant="solid"
          onClick={() => {
            handleClose();
            onContinue?.();
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { AddressSuppliedModal };
